export enum AlturaMenuEnum {
  default = 'auto',
  full = '100%',
  sss = 175,
  ss = 185,
  xss = 200,
  xs = 225,
  sm = 250,
  md = 275,
  xl = 300,
  xll = 325
}

export interface CustomSelectOption {
  label: string;
  value: any;
  selected?: string;
}

export interface CustomSelectProps {
  options: Array<CustomSelectOption>;
  onChange: (value?: any) => void;
  label?: string;
  id?: string;
  loadingMessage?: string;
  menuMaxHeight: {
    mobile: number | string;
    tablet: number | string;
    desktop: number | string;
  };
  value?: any;
  placeholder?: string;
  multiple?: boolean;
  error?: boolean;
  helperText?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  disableFilter?: boolean;
  loading?: boolean;
  disabled?: boolean;
}